export const lightTheme = [
  "--title: #232931",
  "--start: #182952",
  "--end:#5555",
  "--wall:#3fa7d6",
  "--first: #3fa7d6",
  "--second: #ee6352",
  "--third: #fac05e",
  "--background: #f4f4f4",
  "--done:#59cd90",
];

export const darkTheme = [
  "--title: #ffffff",
  "--start: #182952",
  "--first: #3700b3",
  "--second: #03dac6",
  "--third: #cf6679",
  "--background: #121212",
  "--done:#bb86fc",
];
